import windowLocation from 'apps/utility/windowLocation'

const fakeQueryParams = {}

function queryParam(param) {
  const url = windowLocation.getHref()

  if (param in fakeQueryParams) {
    return fakeQueryParams[param]
  }

  const name = param.replace(/[[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) return ''
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

function queryParamsAll(urlSearchString, decodeParams = true) {
  const arrayObj = {}
  if (
    urlSearchString &&
    (urlSearchString.indexOf('&') || urlSearchString.indexOf('=') > -1)
  ) {
    const paramArray = urlSearchString.split('&')
    paramArray[0] = paramArray[0].substring(1)
    for (let i = 0; paramArray.length > i; i++) {
      const splitParam = paramArray[i].split('=')
      if (splitParam[0]) {
        arrayObj[splitParam[0]] = decodeParams
          ? decodeUrlParameter(splitParam[1])
          : splitParam[1]
      }
    }
  }
  return arrayObj
}

function setQueryParam(param, value) {
  fakeQueryParams[param] = value
}

function decodeUrlParameter(string) {
  return decodeURIComponent((string + '').replace(/\+/g, '%20'))
}

export { queryParam, queryParamsAll, setQueryParam, windowLocation }
